<mat-form-field appearance="fill">
  <mat-label>Alias</mat-label>
  <input matInput [formControl]="aliasControl" />
  <mat-spinner matSuffix color="primary" diameter="25" *ngIf="IS_LOADING"></mat-spinner>
  <mat-error *ngIf="aliasControl.hasError('taken')">Aliaset är upptaget</mat-error>
</mat-form-field>
